"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-matchmedia-connect/lib/utils/capitalize.js
// module id = 1396
// module chunks = 0